<template>
  <div class="container-fluid">
    <div class="card">
      <a class="margin__bottom" ref="add" @click="addRow">Adicionar Campo</a>
      <div class="add__lead" v-for="(leads, index) in total" :key="index" :id="index">
        <input type="text" v-model="leads.lead">
        <a class="margin__button" @click="removeRow(index);">Remove</a>
      </div>
      <a>Gerar Links</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "invite-leaders",
  props: ["totalLeads"],
  data() {
    return {
      totalItemsToAdd: 0,
      total: [lead => ""]
    };
  },
  methods: {
    addRow() {
      if (this.total.length + 1 <= this.thistotalItemsToAdd) {
        this.total.push({
          lead: ""
        });
      }
      if (this.total.length + 1 > this.thistotalItemsToAdd) {
        this.$refs.add.classList.add("disabled");
      }
    },
    removeRow(index) {
      if (this.total.length > 1) {
        this.total.splice(index, 1);
        this.$refs.add.classList.remove("disabled");
      }
    }
  },
  created() {
    this.thistotalItemsToAdd = 5 - (this.totalLeads % 5);
  },
  mounted() {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.add__lead {
  display: flex;
}
a {
  display: block;
  background: #0294ff;
  color: white;
  height: 40px;
  font-weight: 700;
  border-radius: 4px;
  padding: 0 0.4rem;
  transition: 0.3s all;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-touch-callout: none;
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none;
  -ms-user-select: none; 
  &:hover {
    background: #30a9ff;
  }
  &.disabled {
    background: grey;
    cursor: no-drop;
  }
}
.button__disabled {
  background: grey;
}
.margin__button {
  margin-left: 1rem;
  margin-bottom: 0.5rem;
}
.margin__bottom {
  margin-bottom: 0.5rem;
}
input {
  margin-bottom: 20px;
  height: 40px;
  line-height: 40px;
  color: #3d3d3d;
  border-radius: 6px;
  border: none;
  height: 45px;
  text-indent: 40px;
  -webkit-box-shadow: 0px 10px 23px 0px rgba(240, 240, 240, 1);
  -moz-box-shadow: 0px 10px 23px 0px rgba(240, 240, 240, 1);
  box-shadow: 0px 10px 23px 0px rgba(240, 240, 240, 1);
  border: 2px solid #fff;
  transition: 0.3s all;
  &:hover {
    border: 2px solid #007aff;
    -webkit-box-shadow: 0px 10px 23px 0px #cad1d7;
    -moz-box-shadow: 0px 10px 23px 0px #cad1d7;
    box-shadow: 0px 10px 23px 0px #cad1d7;
    outline: none;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/inviteLeaders.vue